import { Message, Modal, Typography } from '@arco-design/web-react';
import PillTag from '../PillTag';
import { usePhoneStore } from '../../store/phone';
import { maskPhone } from '../../utils/format';
import { builtinLabel, isDialplanTarget } from '../../utils/labels';
import { hangupCauseLabel } from '../../api/cdr';

/** 主叫/被叫点击回拨：确认一次后经软电话外呼（未注册时提示）；内置 dialplan 目标非可拨号码，展示中文且不可点击 */
export function CallBackLink({ number }: { number?: string }) {
  const phone = usePhoneStore();
  const t = (number || '').trim();
  if (!t) return <span>-</span>;
  if (isDialplanTarget(t)) {
    return <Typography.Text>{builtinLabel(t)}</Typography.Text>;
  }
  const doCall = () => {
    if (!['registered', 'ringing-in', 'ringing-out', 'in-call'].includes(phone.status)) {
      Message.warning('软电话未注册，无法回拨');
      return;
    }
    Modal.confirm({
      title: '回拨确认',
      // 确认文案里的号码同样脱敏（坐席界面不出现完整号码）；呼出仍传原文 t，脱敏只影响展示
      content: `确定拨打 ${maskPhone(t)} 吗？`,
      okText: '拨打',
      cancelText: '取消',
      onOk: () => {
        void phone.call(t);
      },
    });
  };
  return (
    <Typography.Text
      onClick={doCall}
      style={{ cursor: 'pointer', color: 'rgb(var(--link-6))', textDecoration: 'underline' }}
    >
      {maskPhone(t)}
    </Typography.Text>
  );
}

/** 状态列：hangup_cause → 中文（正常挂断为绿色，其余原因为橙色，未知原样显示）。
 *  connected=false（answer_time 为空/未接通）时 NORMAL_CLEARING 显示「未接通」而非「正常挂断」。 */
export function HangupCauseTag({ cause, connected }: { cause?: string; connected?: boolean }) {
  if (!cause) return <span>-</span>;
  const mislabeled = cause === 'NORMAL_CLEARING' && connected === false;
  const label = hangupCauseLabel(cause, connected);
  return <PillTag color={!mislabeled && cause === 'NORMAL_CLEARING' ? 'green' : 'orange'}>{label}</PillTag>;
}
